import React from 'react';
import { Lightbulb } from 'lucide-react';

export default function EmptyState({ message, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="empty-state">
      <div className="w-24 h-24 rounded-full bg-keep-accentBgSoft flex items-center justify-center mb-5">
        <Lightbulb className="w-12 h-12 text-keep-accent" strokeWidth={1.5} />
      </div>
      <div className="text-keep-textMuted text-[22px] font-light mb-1">{message}</div>
      {hint ? <div className="text-keep-textFaint text-[13.5px] max-w-md mt-1">{hint}</div> : null}
    </div>
  );
}
